import { CalendarHeart, MessageCircle } from "lucide-react";
import { DORIE_URL, WHATSAPP_URL } from "../constants";

export const FloatingButtons = () => (
    <div
        data-testid="floating-buttons"
        className="fixed bottom-3 left-3 z-50 flex flex-col items-start gap-2.5 md:hidden"
    >
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-button"
            aria-label="تواصلي عبر واتساب"
            className="flex h-11 w-11 items-center justify-center rounded-full bg-miam-green text-white shadow-lg transition-[transform,background-color] duration-300 hover:scale-105 hover:bg-miam-green-dark"
        >
            <MessageCircle className="h-5 w-5" aria-hidden="true" />
        </a>
        <a
            href={DORIE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-booking-button"
            aria-label="احجزي موعداً"
            className="inline-flex items-center gap-1.5 rounded-full bg-miam-rose px-4 py-2.5 text-xs font-bold text-white shadow-lg transition-[transform,background-color] duration-300 hover:scale-105 hover:bg-miam-rose-dark"
        >
            <CalendarHeart className="h-4 w-4" aria-hidden="true" />
            احجزي موعداً
        </a>
    </div>
);
